import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  I18nModule,
  UrlModule,
} from '@spartacus/core';
import { FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule } from '@spartacus/storefront';
import { GenLoginFormComponent } from './login-form.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
    PasswordVisibilityToggleModule,
  ],
  declarations: [GenLoginFormComponent],
})
export class GenLoginFormModule {}
